const visitorAppointment = {
  msg: {
    organization: 'Organization',
    enterOrganization: 'Please enter organization name',
    appointmentInfo: 'Appointment Information',
    campus: 'Campus',
    selectCampus: 'Please select a campus',
    visitReason: 'Visit reason',
    others: 'Others',
    enterVisitReason: 'Please enter the reason for your visit',
    personToVisit: 'Person to visit',
    enterPersonToVisit: 'Please enter person to visit',
    department: 'Department',
    enterDepartment: 'Please select a department',
    apptTime: 'Appt. Time',
    selectApptTime: 'Please select appointment time',
    vehicleInfo: 'Vehicle Information',
    driving: 'Driving',
    licensePlate: 'License plate',
    enterLicensePlate: 'Please enter license plate number',
    readAndAgree: 'Read and agree to',
    safetyInstructions: "《L'Oréal Safety Instructions for Entry into the Campus》",
    submit: 'Submit',
    appointmentTimePicker: 'Appointment time',
    confirm: 'Confirm',
    cancel: 'Cancel',
    readCarefully: 'Please read carefully, ',
    secondsRemaining: ' seconds remaining',
    readingComplete: 'Reading complete, please scroll to the bottom',
    readCheckAgreement: 'Read, check agreement',
    readingInProgress: 'Reading in progress, ',
    beforeChecking: 's before checking',
    submitting: 'Submitting...',
    loading: 'Loading...',
    pleaseAgreeSafety: 'Please read and agree to the safety instructions first',
    readingCompleteCanAgree: 'Reading complete, you can now check the agreement',
    pleaseReadSafety: 'Please read the safety instructions first',
    switchLang: '中文'
  }
};
export default visitorAppointment



// WEBPACK FOOTER //
// ./src/page/visitor/visitorAppointment/lang/visitorAppointment.en.js